// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.funnel_panel{display:inline-block;background:#fff;width:100%;padding:48px 0 0}`, "",{"version":3,"sources":["webpack://./src/matchScreen/styles/WelcomeSection/WelcomeSection.scss","webpack://./src/matchScreen/styles/shared/constants.scss"],"names":[],"mappings":"AAEA,cACE,oBAAA,CACA,eCWM,CDVN,UAAA,CACA,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
